import Container from './Container';
import View from './View';

export default Container(View);
